import { Component, input } from '@angular/core';

/**
 * @ngdoc component
 * @name ApButtonGroupItemComponent
 * @description component for a button which is part of a ApButtonGroupComponent See {@link ApButtonGroupComponent} for example.
 */
@Component({
    selector: 'ap-button-group-item',
    templateUrl: './button-group-item.component.html'
})
export class ApButtonGroupItemComponent {
    /**
     * Required - The value of the button when selected
     */
    readonly value = input.required<string>();

    /**
     * Required - The label to show on the button
     */
    readonly label = input.required<string>();
}
